import React from 'react';

export const UNIFORM_REF_BADGE_WIDTH = 52;

export const ZOHO_AUTO_MAPPED_ACCOUNTS = [
  { code: '800', label: 'Accounts Payable' },
  { code: '610', label: 'Accounts Receivable' },
  { code: '2351', label: 'Output VAT' },
];

export const splitMappingFields = (fields, splitAt = 7) => {
  const mid = Math.min(splitAt, fields.length);
  return [fields.slice(0, mid), fields.slice(mid)];
};

export const UniformRefBadge = ({ code }) => (
  <span
    className="text-muted"
    style={{
      display: 'inline-block',
      width: UNIFORM_REF_BADGE_WIDTH,
      flexShrink: 0,
      boxSizing: 'border-box',
      fontSize: '0.625rem',
      fontWeight: 600,
      background: 'var(--bs-secondary-bg)',
      padding: '2px 4px',
      borderRadius: 3,
      textAlign: 'center',
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
      fontVariantNumeric: 'tabular-nums',
    }}
  >
    {code}
  </span>
);

export const MappedValuePill = ({ mapped, label }) => {
  if (mapped && label) {
    return (
      <span
        className="badge bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle fw-normal text-truncate"
        style={{ maxWidth: '100%', fontSize: '0.75rem', fontWeight: 500 }}
        title={label}
      >
        {label}
      </span>
    );
  }

  return (
    <span
      className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle fw-normal"
      style={{ fontSize: '0.75rem', fontWeight: 500 }}
    >
      Not mapped
    </span>
  );
};

export const AutoMappedFooterStrip = () => (
  <div
    className="rounded text-center"
    style={{
      padding: '12px 14px',
      background: 'var(--bs-tertiary-bg)',
    }}
  >
    <div className="small fw-medium mb-2">Auto-mapped in Zoho</div>
    <div className="d-flex flex-wrap justify-content-center gap-2">
      {ZOHO_AUTO_MAPPED_ACCOUNTS.map((account) => (
        <span
          key={account.code}
          className="badge bg-info-subtle text-info-emphasis border border-info-subtle fw-normal"
          style={{ fontSize: '0.75rem', fontWeight: 500 }}
        >
          {account.code} · {account.label}
        </span>
      ))}
    </div>
  </div>
);
